import React, { useRef, useState } from 'react'

import { uniq } from 'lodash'
import { Braces, ChevronDown, ChevronRight } from 'lucide-react'
import { CommandGroupSearch, CommandItemSearch, CommandSearch, DefaultPopover } from 'twyne-new.ui'

import { TruncateWithTooltipFormatter } from '@Components/Grid/components/Table/formatters'

import mergetagDescriptions from './Descriptions'

export default function MergetagPopover({ mergetags = [], onSelect, onOpen, disabled }) {
  const [open, setOpen] = useState(false)
  const searchRef = useRef(null)

  const handleOpenChange = nextOpen => {
    setOpen(nextOpen)
    nextOpen && onOpen?.()
  }

  const handleSelect = tag => {
    setOpen(false)
    onSelect(tag)
  }

  return <DefaultPopover
    title='Insert mergetag at cursor'
    wrapperProps={{ open, onOpenChange: handleOpenChange }}
    triggerProps={{ disabled, className: 'flex items-center gap-2 h-full px-3 rounded-r-xs whitespace-nowrap cursor-pointer transition-colors duration-200 ease-in-out enabled:hover:twy-subtle-neutral data-[state=open]:twy-subtle-neutral disabled:cursor-not-allowed' }}
    contentProps={{
      align: 'end',
      onOpenAutoFocus: event => {
        event.preventDefault()
        searchRef.current?.focus()
      },
    }}
    trigger={<>
      <Braces size={14} className='twy-text-accent' />
      Mergetag
      <ChevronDown size={14} />
    </>}
  >
    <CommandSearch placeholder='Search...' inputProps={{
      ref: searchRef,
      hasIcon: false,
      classNameContainer: 'p-0 pb-2 border-b-0',
      className: 'p-2 border twy-border-base focus:border-blue-400 transition duration-200 ease-in-out',
    }}>
      <CommandGroupSearch heading=''>
        {uniq(mergetags.map(tag => `${tag}`)).map(tag => <CommandItemSearch key={tag} value={tag} onSelect={() => handleSelect(tag)}>
          <MergetagItem tag={tag} />
        </CommandItemSearch>)}
      </CommandGroupSearch>
    </CommandSearch>
  </DefaultPopover>
}

function MergetagItem({ tag }) {
  const { short, long } = mergetagDescriptions[tag] || {}

  return <span className='flex items-center gap-2 w-full min-w-0'>
    <TruncateWithTooltipFormatter value={`{${tag}}`} className={short ? 'shrink-0 max-w-[60%]' : 'min-w-0'} />
    {short && <TruncateWithTooltipFormatter value={short} className='min-w-0 text-sm twy-text-base-neutral' />}
    {long && <span className='ml-auto shrink-0' onClick={event => event.stopPropagation()}>
      <DefaultPopover
        title={`{${tag}}`}
        triggerProps={{ className: 'flex items-center p-0.5 rounded-xs cursor-pointer opacity-0 in-data-[selected=true]:opacity-100 data-[state=open]:opacity-100 hover:twy-subtle-neutral transition-opacity' }}
        contentProps={{ side: 'right', align: 'start', sideOffset: 12, className: 'w-80' }}
        trigger={<ChevronRight size={14} />}
      >
        <p className='twy-text-base-accent'>{long}</p>
      </DefaultPopover>
    </span>}
  </span>
}
